<div class="flex-fill d-flex flex-column">
    <div class="card d-flex">
        <div class="card-body flex-column" style="max-width: 1050px">
            <div class="d-flex flex-row">
                <dx-form [formData]="filter" (onEditorEnterKey)="search()">
                    <dxi-item itemType="group">
                        <dxi-item dataField="report" editorType="dxSelectBox" [label]="{ text: 'Report' }" [editorOptions]="{ items: reports,}"></dxi-item>
                        <dxi-item dataField="startDate" editorType="dxDateBox" [label]="{ text: 'Start' }" [editorOptions]="{}"></dxi-item>
                        <dxi-item dataField="endDate" editorType="dxDateBox" [label]="{ text: 'End' }" [editorOptions]="{}"></dxi-item>
                        <dxi-item dataField="basedOnDate" editorType="dxCheckBox" [label]="{ text: (filter?.report === 'OnTime Build' ? 'Based on Built' : 'Based On Delivered') }" [editorOptions]="{}"></dxi-item>
                    </dxi-item>
                </dx-form>
                <div class="card-body">
                    <div *ngIf="entities" class="d-flex flex-column"></div>
                </div>
            </div>
            <div class="btn-toolbar justify-content-start align-items-center mt-3">
                <div *ngIf="entities" class="me-3">{{ entities.length }} {{ entities.length === 1 ? 'item found' : 'items found' }}</div>
                <button accesskey="s" (click)="search()" class="btn btn-primary">Search</button>
                <button (click)="clear()" class="btn btn-secondary ms-2">Clear</button>
                <div class="ms-5 me-3 average-text">Average (days): {{ average | number : '1.2-2' }}</div>
                <div class="ms-3 on-time-text" [ngClass]="onTimePercentage >= onTimeTargetPercent / 100 ? ' on-time' : ' late'">OnTime: {{ onTimePercentage | percent : '1.2-2' }}</div>
            </div>
        </div>
    </div>
    <div class="d-flex" *ngIf="chartEntities">
        <div class="col-sm-9">
            <dx-chart id="chart" title="OnTime" [dataSource]="chartEntities" [style]="{height: '325px'}">
                <dxi-series valueField="onTimeCount" name="On Time" color="green"></dxi-series>
                <dxi-series valueField="lateCount" name="Late" color="red"></dxi-series>
                <dxi-value-axis position="left">
                    <dxo-title text="Count"></dxo-title>
                </dxi-value-axis>
                <dxo-common-series-settings argumentField="weekDue" type="stackedBar"></dxo-common-series-settings>
                <dxo-legend verticalAlignment="bottom" horizontalAlignment="center" itemTextPosition="top"> </dxo-legend>
                <dxo-export [enabled]="true"></dxo-export>
                <dxo-tooltip [enabled]="true" location="edge" [customizeTooltip]="customizeTooltip"> </dxo-tooltip>
            </dx-chart>
        </div>
        <div class="col-sm-3">
            <dx-chart #chart title="Overall" [dataSource]="summaryChart"  [style]="{height: '325px'}">
                 <dxi-series valueField="onTimeTrailers" name="OnTime" color="green"></dxi-series>
                <dxi-series valueField="lateTrailers" name="Late" color="red"> </dxi-series>
                <dxi-series valueField="unKnownCount" name="N/A" color="blue"> </dxi-series>
                <dxi-value-axis position="left">
                    <dxo-title text="% OnTime"></dxo-title>
                </dxi-value-axis>
                <dxo-common-series-settings argumentField="series" type="stackedBar">
                    <dxo-border [color]="'black'" [width]="3" [visible]="true"></dxo-border>
                </dxo-common-series-settings>
                <dxo-legend verticalAlignment="bottom" horizontalAlignment="center" itemTextPosition="top"> </dxo-legend>
                <dxo-export [enabled]="true"></dxo-export>
                <dxo-tooltip [enabled]="true" location="edge"> </dxo-tooltip>
            </dx-chart>
        </div>
    </div>

    <div class="m-1 grid-fill" *ngIf="entities">
        <dx-data-grid
            #dataGrid
            [dataSource]="entities"
            keyExpr="id"
            [columnAutoWidth]="false"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onOptionChanged)="onOptionChanged($event)"
            (onContentReady)="onContentReady($event)"
            (onExporting)="onExporting($event)"
            (onRowDblClick)="onRowDoubleClick($event)"
        >
            <dxi-column dataField="orderNumber" caption="Order #" alignment="left"  width="100"></dxi-column>
            <dxi-column dataField="dealer" width="150"></dxi-column>
            <dxi-column dataField="partNumber" width="150"></dxi-column>
            <dxi-column dataField="description" width="150"></dxi-column>
            <dxi-column dataField="vin" width="150"></dxi-column>
            <dxi-column dataField="created" dataType="date" width="100"></dxi-column>
            <dxi-column dataField="buildDue" dataType="date" width="100" [visible]="build" ></dxi-column>
            <dxi-column dataField="built" dataType="date" width="100"  [visible]="build"></dxi-column>
            <dxi-column dataField="deliveryDue" dataType="date" width="100" [visible]="delivery" ></dxi-column>
            <dxi-column dataField="delivered" dataType="date" width="100"  [visible]="delivery"></dxi-column>
            <dxi-column dataField="daysOnTime" width="100" [format]="{ type: 'fixedPoint', precision: 2 }"></dxi-column>

            <dxi-column dataField="" width="25"></dxi-column>

            <dxo-remote-operations [sorting]="true" [paging]="true" [filtering]="true"></dxo-remote-operations>
            <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
            <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-state-storing [enabled]="true" type="localStorage" storageKey="timing-overview-grid"></dxo-state-storing>
            <dxo-selection [mode]="'multiple'"></dxo-selection>

            <div *dxTemplate="let cell of 'ordersTemplate'">
                <a *ngFor="let invoiceNumber of cell.data.ordersList" [routerLink]="[]" (click)="openInvoiceOrder(invoiceNumber)">{{ invoiceNumber || '' }} </a>
            </div>

            <div *dxTemplate="let cell of 'packSlipTemplate'">
                <a *ngFor="let packSlipNumber of cell.data.packingSlipList" [routerLink]="[]" (click)="printPackingSlip(packSlipNumber)">{{ packSlipNumber || '' }} </a>
            </div>

            <div *dxTemplate="let cell of 'printTemplate'">
                <a [routerLink]="[]" (click)="printInvoice(cell)">{{ cell.value || '' }}</a>
            </div>

            <div *dxTemplate="let data of 'toolbarButtons'">
                <!-- <button class="btn btn-success" (click)="open(dataGrid.instance.getSelectedRowsData()[0])" [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1">
                    Open
                </button> -->

                <!-- <button class="btn btn-secondary ms-2" (click)="queueForQBBridge()" [disabled]="dataGrid.instance.getSelectedRowsData().length === 0">Queue for Bridge</button> -->
            </div>
            <div *dxTemplate="let data of 'toolbarText'">
                <span *ngIf="entities" class="me-3">
                    <strong>
                        {{ dataGrid.instance.totalCount() + ' items' }}
                        {{ dataGrid.instance.getSelectedRowsData().length > 0 ? dataGrid.instance.getSelectedRowsData().length + ' selected' : '' }}
                    </strong>
                </span>
            </div>
        </dx-data-grid>
    </div>
</div>
